export function formatTime(seconds) {
 if (!seconds || seconds <= 0) return "0 Sec"
 if (seconds < 60) {
 return `${seconds} Sec`
 } else if (seconds < 3600) {
 const mins = Math.floor(seconds / 60)
 const secs = seconds % 60
 return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")} Mins`
 } else {
 const hrs = Math.floor(seconds / 3600)
 const mins = Math.floor((seconds % 3600) / 60)
 const secs = seconds % 60
 return `${String(hrs).padStart(2, "0")}:${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")} Hrs`
 }
 }